/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Container for LazySection that sets forceInView when state.app.bot is true
 */

import { connect } from 'react-redux'

import { LazySectionProps } from './LazySection'
import { MemoLazySection } from './MemoLazySection'
import { getSelectIsBot } from './selectIsBot'

interface OwnProps {
  forceInView?: boolean
}

const mapStateToProps = (state: unknown, ownProps: OwnProps) => {
  const isBot: boolean = getSelectIsBot()(state)
  return {
    forceInView:
      ownProps.forceInView === undefined ? isBot : ownProps.forceInView,
  }
}

export interface LazySectionContainerProps<ForwardProps extends {}>
  extends Omit<LazySectionProps<ForwardProps>, 'forceInView'>,
    OwnProps {}

export const LazySectionContainer = connect(
  mapStateToProps,
  {}
)(MemoLazySection) as <ForwardProps extends object>(
  props: LazySectionContainerProps<ForwardProps>
) => JSX.Element
